//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
import ConfirmState from'./d2-confirm-state/'
export default {
  components: {
    DialogAddCategory: () => import('../DialogAddCategory/index.vue'),
    DialogEditCategory: () => import('../DialogEditCategory/index.vue'),
    DialogGoods: () => import('@/index/pages/operate/goods/goodsTabs/components/DialogGoods/index.vue'),
    ConfirmState,
  },
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      currentTableData: this.tableData,
      rowData: {
        default: () => ({})
      },
      addDialogVisible: false,
      editDialogVisible: false,
      goodsDialogVisible: false
    }
  },
  created(){
  },
  watch: {
    tableData: {
      handler (val) {
        let i = 0
        // val.forEach(e=>{
        //   console.log(e.sort)
        // })
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
    handleDisplayRow (row, num) {
      console.log(row)
      let data = { 
        categoryId: row.categoryId,
        hideStatus: num
      }
      this.$axios.post('/mtea/store/admin/goods/category/hide', data).then(res => {this.$emit('submit')})
    },
    goodsTypeOrder (row,num) {
      let data = {
        newSort: row.sort,
        categoryId: row.categoryId
      }
      for( let i = 0; i<this.currentTableData.length; i++){
        if(row.categoryId === this.currentTableData[i].categoryId){
          data.newSort = this.currentTableData[i + num].sort
          break
        }
      }
      this.$axios.post('/mtea/store/admin/goods/category/sort', data).then(res => {this.$emit('submit')})
    },
    handleDeleteRow: function (row) {
      let data = {id: row.categoryId}
      // console.log('data', data)
      this.$axios.post('/mtea/store/admin/goods/category/del', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
      }).finally(() => {

      })
    }
  }
}
